import IpadsMini from './IpadsMini';

export default IpadsMini;
